( function( $ ) {
	/**
	 * @credit http://indiegamr.com/generate-repeatable-random-numbers-in-js/
	 *
	 * @constructor
	 */
	SeededRandom = function(seed, max, min) {
		this.seed = seed;
		this.max = max;
		this.min = min;
	}

	SeededRandom.prototype.constructor = SeededRandom;
	SeededRandom.prototype.generate = function() {
		max = this.max || 1;
		min = this.min || 0;

		this.seed = (this.seed * 9301 + 49297) % 233280;
		var rnd = this.seed / 233280;

		return min + rnd * (max - min);
	}

	/**
	 * @credit https://css-tricks.com/snippets/jquery/shuffle-dom-elements/
	 * @returns {*|jQuery|HTMLElement}
	 */
	$.fn.shuffleWithSeed = function (seed) {
		var seedRandom = new SeededRandom(seed);

		var allElems = this.get(),
			getRandom = function(max) {
				return Math.floor(seedRandom.generate() * max);
			},
			shuffled = $.map(allElems, function(){
				var random = getRandom(allElems.length),
					randEl = $(allElems[random]).clone(true)[0];
				allElems.splice(random, 1);
				return randEl;
			});

		this.each(function(i){
			$(this).replaceWith($(shuffled[i]));
		});

		return $(shuffled);
	};

	/**
	 * Convert field ID string to number to aide with seeding.
	 *
	 * @param string
	 * @returns number
	 */
	var fieldIDToNumber = function(string) {
		return string
			.split('')
			.map(function(char) {
				return char.charCodeAt(0);
			})
			.reduce(function(accumulator, currentValue) {
				return accumulator + currentValue;
			})
	}

	$.fn.gprRandomizeOrder = function() {
		var seed = $(this).parents('form').find('[name="gpr_seed"]').val();

		if (!seed) {
			console.warn('GP Randomizer: seed not available');
			return;
		}

		this.each(function() {
			/* Do not re-shuffle already shuffled choices. */
			if ($(this).find('.ginput_container').data('gprShuffledOrder')) {
				return;
			}

			var formId = $(this)
				.closest('form')
				.attr('id')
				.replace('gform_', '');

			var fieldId = $(this).attr('id').split('_').pop();

			var $elsToShuffle = jQuery();

			/* Add field ID into seed to  */
			var fieldSeed = seed + fieldIDToNumber($(this).attr('id'));

			/* Drop Downs */
			$elsToShuffle = $elsToShuffle.add($(this).find('select option'));

			/* Checkboxes / Radios */
			$elsToShuffle = $elsToShuffle.add(
				$(this)
					.find('[class*="gchoice_"]')
					.filter(function () {
						var $input = $(this).find('input');
						// Exclude elements that contain "gf_other_choice" or have class "gchoice_other_control".
						return $input.val() !== 'gf_other_choice' && !$(this).hasClass('gchoice_other_control');
					})
			);

			/* Survey Add-On Rank Fields */
			var $surveyRankUl = $(this).find('ul.gsurvey-rank');
			var updateSurveyRank = false;

			if ($surveyRankUl.length) {
				$elsToShuffle = $elsToShuffle.add(
					$surveyRankUl.find('li.gsurvey-rank-choice')
				);

				var surveyItemHiddenInput = $(
					'#' + $surveyRankUl.attr('id') + '-hidden'
				);

				var defaultOrder = $surveyRankUl
					.closest('.gsurvey-survey-field')
					.data('default-order');

				if (defaultOrder.join(',') === surveyItemHiddenInput.val()) {
					if (typeof gsurveyRankUpdateRank === 'function') {
						updateSurveyRank = true;
					}
				}
			}

			/**
			 * Filter the individual elements to be shuffled inside a field. Useful for excluding
			 * certain choices from being shuffled.
			 *
			 * @param JQuery $elsToShuffle The jQuery elements to be shuffled.
			 * @param int formId The current form ID.
			 * @param int fieldId The current field ID.
			 *
			 * @since 1.0.5
			 */
			$elsToShuffle = window.gform.applyFilters(
				'gpr_elements_to_shuffle',
				$elsToShuffle,
				formId,
				fieldId
			);

			console.log($elsToShuffle);

			$elsToShuffle.shuffleWithSeed(fieldSeed);

			if (updateSurveyRank) {
				gsurveyRankUpdateRank($surveyRankUl[0]);
			}

			/* Set data to prevent reshuffle later */
			$(this)
				.find('.ginput_container')
				.addClass('gpr-shuffled')
				.data('gprShuffledOrder', true);
		});
	};

	window.GPRandomizer = function(formId) {
		var self = this;
		this.formId = formId;

		this.randomizeChoiceOrder = function() {
			$( '#gform_wrapper_' + self.formId ).find('.gpr_randomize_field').gprRandomizeOrder();
		}

		this.bind = function() {
			/**
			 * Immediately randomize choice order.
			 */
			self.randomizeChoiceOrder();

			/**
			 * Listen for when Populate Anything updates fields and re-randomize choice order.
			 */
			$(document).on('gppa_updated_batch_fields', self.randomizeChoiceOrder);
		}

		this.bind();
	}
})(jQuery);
